module.exports = __webpack_public_path__ + "img/图1-1  机器学习与人类思考的类比.c003cbbf.png";